import { mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { ChevronDownIcon, OldPhoneFilledIcon } from '../../icons';

const flagWidth = 22;
const flagBorderRadius = 2;

export const PhoneSection = styled.div<StyledMods<{ withLabel?: boolean }>>`
    position: relative;
    width: 100%;

    // base on https://gitlab.com/catamphetamine/react-phone-number-input/-/blob/master/style.css

    .PhoneInput {
        display: flex;
        align-items: center;
    }

    .PhoneInputInput {
        flex: 1;
        min-width: 0;
    }

    .PhoneInputCountry {
        z-index: 1;
        position: absolute;
        left: 12px;
        top: 0;
        align-self: stretch;
        display: flex;
        align-items: center;
        height: 40px;
        overflow: hidden;

        ${mods('withLabel', true)`
            top: 16px;
        `};
    }

    .PhoneInputCountryIcon {
        width: ${flagWidth}px;
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .PhoneInputCountryIcon--border {
        position: relative;

        &::after {
            box-shadow: 0 0 0 1px inset rgba(0, 0, 0, 0.1);
            content: '';
            display: block;
            height: 100%;
            position: absolute;
            top: 0;
            width: 100%;
            border-radius: ${flagBorderRadius}px;
        }
    }

    .PhoneInputCountryIconImg {
        display: block;
        width: ${flagWidth}px;
        height: 15px;
        border-radius: ${flagBorderRadius}px;
    }

    .PhoneInputCountrySelect {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 1;
        border: 0;
        opacity: 0;
        cursor: pointer;
    }
`;

export const StyledMiniPhone = styled(OldPhoneFilledIcon)`
    color: ${theme.color.midnight70};
`;

export const ArrowIcon = styled(ChevronDownIcon)`
    margin: 0 7px;
    flex: none;
`;
